import { useState, useEffect, useCallback } from "react";
import { getSiteAnalytics } from "../services/analyticsService";

/**
 * Custom hook for fetching site analytics data
 * @param {string|number} tenantId - Tenant ID
 * @returns {Object} { data, loading, error, refresh }
 */
export const useSiteAnalytics = (tenantId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!tenantId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const response = await getSiteAnalytics(tenantId);
      
      if (response?.success && response?.data) {
        setData(response.data);
      } else {
        setError(new Error("Failed to load reports data"));
      }
    } catch (err) {
      console.error("Error fetching site analytics:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [tenantId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const refresh = useCallback(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refresh };
};
